import { fetchJson } from '../utils/http';
const featureSwitches = ['prezi-design-analytics-viewlinks'];
export const getFeatureSwitches = () => {
  return fetchJson('/api/v1/featureswitches/', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      feature_switches: featureSwitches
    })
  });
};